// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shop-carousel-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 50px;
}

.shop-carousel-container h1{
    font-family: 'Philosopher',serif;
    font-style: italic;
}

.cards-container {
    display: flex;
    overflow: hidden;
    /* width: 80%; */
    /* Adjust based on button width */
    margin: 20px 20px;
    /* Space around the cards */
}

.carousel-card {
    background: #fff;
    /* padding: 10px; */
    border-radius: 8px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
    margin: 20px 10px;
    
        width: 300px;
        height: 500px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
   
}





.carousel-card img{
    width:200px;
    margin-top: 50px;
}

.carousel-card img:hover{
   transform: scale(1.1);
}

.carousel-card h5{
    text-align: center;
    font-family: 'Philosopher',serif;
    margin:0px 0px;
    

}

.carousel-card-information{
    margin-bottom:20px;
    margin-top: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
}

.cart-class{
    width:40px;
    height:40px;
    border: rgba(0, 0, 0, 0.3);
    border-style: solid;
    border-radius: 20px;
    border-width: 1px;
    margin-bottom: 20px;
    margin-top: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    justify-items: center;
    align-content: center;
    padding: 0px;
}

.cart-class button{
    width:15px;
    height:15px;
    padding: 0px;
    margin-left: 0px;
    border:none;
    cursor: pointer;
    
}

.cart-class button:hover{
    color: #e42727;
}

.Scroll-cards{
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items:center;
}

.Scroll-cards p{
    font-family: 'Poppins',sans-serif;
    font-size: 14px;
    width:20px;
    color:#e42727;
}
.Scroll-cards button{
    border:rgba(0, 0, 0, 0.3);
    border-style: solid;
    border-width: 1px;
    
}

.left-scroll{
    border-bottom-left-radius: 15px;
    border-top-left-radius: 15px;
    font-size: 14px;
    width:30px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    z-index: 0;
}


.right-scroll {
    border-bottom-right-radius: 15px;
    border-top-right-radius: 15px;
    font-size: 14px;
    width:30px;
    cursor: pointer;
}

.price-container{
    display: flex;
        flex-direction: row;
        align-items: center;
       

}

.price-container p{
    margin:10px;
    margin-left:0px;
}

.review-stars{
   /* margin-bottom:20px;
   margin-top: auto; */
   min-height: 17.6px;
   margin:20px;
   margin-left: 0px;
}

.cart-class button{
    background-color: #fff;
}


.left-scroll:hover,.right-scroll:hover{
    background-color: #e42727;
}


`, "",{"version":3,"sources":["webpack://./src/Styles/Carousal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,2CAA2C;IAC3C,iBAAiB;;QAEb,YAAY;QACZ,aAAa;QACb,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;;AAEvB;;;;;;AAMA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;GACG,qBAAqB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;;;AAGlB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;;AAEnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,UAAU;IACV,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;;AAErB;;AAEA;IACI,+BAA+B;IAC/B,4BAA4B;IAC5B,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,UAAU;AACd;;;AAGA;IACI,gCAAgC;IAChC,6BAA6B;IAC7B,eAAe;IACf,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;QACT,mBAAmB;QACnB,mBAAmB;;;AAG3B;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;GACG;sBACmB;GACnB,kBAAkB;GAClB,WAAW;GACX,gBAAgB;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,yBAAyB;AAC7B","sourcesContent":[".shop-carousel-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 50px;\n}\n\n.shop-carousel-container h1{\n    font-family: 'Philosopher',serif;\n    font-style: italic;\n}\n\n.cards-container {\n    display: flex;\n    overflow: hidden;\n    /* width: 80%; */\n    /* Adjust based on button width */\n    margin: 20px 20px;\n    /* Space around the cards */\n}\n\n.carousel-card {\n    background: #fff;\n    /* padding: 10px; */\n    border-radius: 8px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);\n    margin: 20px 10px;\n    \n        width: 300px;\n        height: 500px;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n   \n}\n\n\n\n\n\n.carousel-card img{\n    width:200px;\n    margin-top: 50px;\n}\n\n.carousel-card img:hover{\n   transform: scale(1.1);\n}\n\n.carousel-card h5{\n    text-align: center;\n    font-family: 'Philosopher',serif;\n    margin:0px 0px;\n    \n\n}\n\n.carousel-card-information{\n    margin-bottom:20px;\n    margin-top: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    \n}\n\n.cart-class{\n    width:40px;\n    height:40px;\n    border: rgba(0, 0, 0, 0.3);\n    border-style: solid;\n    border-radius: 20px;\n    border-width: 1px;\n    margin-bottom: 20px;\n    margin-top: auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    justify-items: center;\n    align-content: center;\n    padding: 0px;\n}\n\n.cart-class button{\n    width:15px;\n    height:15px;\n    padding: 0px;\n    margin-left: 0px;\n    border:none;\n    cursor: pointer;\n    \n}\n\n.cart-class button:hover{\n    color: #e42727;\n}\n\n.Scroll-cards{\n    margin-top: 10px;\n    display: flex;\n    flex-direction: row;\n    align-items:center;\n}\n\n.Scroll-cards p{\n    font-family: 'Poppins',sans-serif;\n    font-size: 14px;\n    width:20px;\n    color:#e42727;\n}\n.Scroll-cards button{\n    border:rgba(0, 0, 0, 0.3);\n    border-style: solid;\n    border-width: 1px;\n    \n}\n\n.left-scroll{\n    border-bottom-left-radius: 15px;\n    border-top-left-radius: 15px;\n    font-size: 14px;\n    width:30px;\n    position: relative;\n    overflow: hidden;\n    cursor: pointer;\n    z-index: 0;\n}\n\n\n.right-scroll {\n    border-bottom-right-radius: 15px;\n    border-top-right-radius: 15px;\n    font-size: 14px;\n    width:30px;\n    cursor: pointer;\n}\n\n.price-container{\n    display: flex;\n        flex-direction: row;\n        align-items: center;\n       \n\n}\n\n.price-container p{\n    margin:10px;\n    margin-left:0px;\n}\n\n.review-stars{\n   /* margin-bottom:20px;\n   margin-top: auto; */\n   min-height: 17.6px;\n   margin:20px;\n   margin-left: 0px;\n}\n\n.cart-class button{\n    background-color: #fff;\n}\n\n\n.left-scroll:hover,.right-scroll:hover{\n    background-color: #e42727;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
